import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

const LIFE_BY_SEVERITY: Record<string, number> = {
  success: 5000,
  info:    5000,
  warn:    10000,
  error:   10000,
};

const DEFAULT_LIFE = 5000;

@Injectable()
export class CustomMessageService extends MessageService {
  override add(message: ToastMessageOptions): void {
    super.add({ life: LIFE_BY_SEVERITY[message.severity ?? 'info'] ?? DEFAULT_LIFE, ...message });
  }

  override addAll(messages: ToastMessageOptions[]): void {
    super.addAll(
      messages.map(m => ({ life: LIFE_BY_SEVERITY[m.severity ?? 'info'] ?? DEFAULT_LIFE, ...m }))
    );
  }
}
